import React, { useRef, useState } from 'react';
import { useTranslation } from '../../locale/useTranslation';
import BossDialog from '../../components/BossDialog';
import { Grid, GridColumn as Column, GridColumn } from "@progress/kendo-react-grid";
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import EditRoundButton from '../../framework/forms/helpercomponents/buttons/EditRoundButton';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import SaveButton from '../../framework/forms/helpercomponents/buttons/SaveButton';
import CancelButton from '../../framework/forms/helpercomponents/buttons/CancelButton';
import ToastNotification from '../../components/ToastNotification';
import { TOAST_TYPES } from '../../framework/constant/constant';

const ReplacementOptionEditForm = (props) => {
    const { data = [], setData, onReplaceSubmit } = props;
    const lang = useTranslation();

    const blankDataItem = {
        Find: "",
        ReplaceValue: ''
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [editMode, setEditMode] = useState(false);
    const [toggle, setToggle] = useState(false);

    const selectedIndexRef = useRef(null);

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    };

    const isValid = () => {

        if (!dataItem.Find || dataItem.Find === "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_find_error_message });
            return false;
        }
        return true;
    }

    const handleSaveData = () => {
    if (!isValid()) return;

    const payload = {
        Find: dataItem?.Find,
        ReplaceValue: dataItem?.ReplaceValue
    };

    const updated = [...data];

    if (editMode) {
        updated[selectedIndexRef.current] = payload;
    } else {
        updated.push(payload);
    }

    onReplaceSubmit(updated);
    clearForm();
};

    const editReplaceData = (props) => {
        selectedIndexRef.current = props.dataIndex;
        setDataItem({
            ...props?.dataItem,
            Find: props?.dataItem?.Find,
            ReplaceValue: props?.dataItem?.ReplaceValue
        });
        setEditMode(true);
        setToggle(true);
    };

    const removeReplaceData = (index) => {
        setData((data || []).filter((_, i) => i !== index));
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
    };

    const clearForm = () => {
        setDataItem(blankDataItem);
        setEditMode(false);
        setToggle(false);
        selectedIndexRef.current = null;
    };

    const CommandCell = (props) => (
        <div className="d-flex gap-1 mt-1">
            <EditRoundButton onClick={() => editReplaceData(props)} />
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removeReplaceData(props.dataIndex), () => { })} />
        </div>
    );

    return (
        <div style={{ height: "100%", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "10px 20px 20px 20px" }}>
            <div className="row">
                <div className="col-12">
                    <AddRoundButton style={{ marginBottom: "5px" }} onClick={() => setToggle(true)} />
                    <span className='float-right' style={{ marginTop: "15px" }}>Replacement</span>
                    <Grid data={data} style={{ height: "20vh" }}>
                        <GridColumn width="90px" cell={CommandCell} locked />
                        <Column field="Find" title={lang.find_column} />
                        <Column field="ReplaceValue" title={lang.replace_value_column} />
                    </Grid>
                </div>
                {toggle && (<BossDialog title={lang.replace_dialog_header} onClose={clearForm} width={500}>
                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="marlr">
                                    {!editMode && (<SaveButton title="Add" onClick={handleSaveData} />)}
                                    {editMode && (<SaveButton title="Save" onClick={handleSaveData} />)}
                                    <CancelButton onClick={clearForm} />
                                </div>
                            </div>
                            <div className="mt-3">
                                <div className='row mt-2'>
                                    <div className="col-6">
                                        <label htmlFor="">{lang.find_label} *</label>
                                        <input
                                            className="form-control form-control-sm"
                                            type="text"
                                            name="Find"
                                            value={dataItem.Find}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label htmlFor="">{lang.replace_value_label} </label>
                                        <input
                                            className="form-control form-control-sm"
                                            type="text"
                                            name="ReplaceValue"
                                            value={dataItem.ReplaceValue}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </BossDialog>
                )}
            </div>
        </div>
    );

}

export default ReplacementOptionEditForm 